const IdentificationDocumentTypes = {
  RUT: 'RUT',
  DNI: 'DNI'
} as const;

type IdentificationDocumentType =
  (typeof IdentificationDocumentTypes)[keyof typeof IdentificationDocumentTypes];

const isRut = (
  docType: IdentificationDocumentType
): docType is IdentificationDocumentType => {
  return docType === IdentificationDocumentTypes.RUT;
};

const isDni = (
  docType: IdentificationDocumentType | undefined
): docType is IdentificationDocumentType => {
  return docType === IdentificationDocumentTypes.DNI;
};

const RECEIPT_DNI_DOCUMENT_NUMBER = '66.666.666-6';

export {
  IdentificationDocumentTypes,
  isDni,
  isRut,
  RECEIPT_DNI_DOCUMENT_NUMBER
};

export type { IdentificationDocumentType };
